<template>
    <div>
        <Tabs :animated="false"   @on-click="roleManagement">
            <TabPane label="员工设置">
                <Table stripe :columns="columns" :data="data" :loading="loadingTable">
                    <template slot-scope="{ row, index }" slot="action">
                        <Button type="primary" size="small" @click="editadmin(row)">详情</Button>
                    </template>
                </Table>
                <div class="pageTotal"  >
                    <Page :total="page.total"
                          show-total
                          :page-size="page.rows"
                          @on-change="onGongPageTotal" />
                </div>
            </TabPane>
            <TabPane label="角色管理" :disabled="isSisabled">
                <Row>
                    <Col span="4">
                        <dl class="position-list">
                            <dt>角色名称</dt>
                            <dd v-for="(k,v) in RoleList" @click="tabRoleFn(k.id, v)">{{k.name}} <Icon type="ios-arrow-forward" size="20" color="#2d8cf0" class="selected-right" v-if="v==rightTive" /></dd>
                        </dl>
                        <Button long style="margin-top: 10px" @click="isShowaddnameFn"><Icon type="ios-add" />添加角色</Button>
                    </Col>
                    <Col span="20">
                        <div class="position-list" style="margin-left: 15px;padding: 15px">
                            <template v-if="isShowaddname">
                                <Input maxlength="20" v-model="rolename" show-word-limit placeholder="新增角色" style="width: 240px"/>
                                <Button type="primary"  @click="adddateRoleFn" style="margin:0 10px">保存</Button>
                                <Button @click="cancelrolename">取消</Button>
                            </template>
                            <br> <br>
                            <Form label-position="top">
                                <FormItem v-for="(item,index) in listsRole">
                                    <Divider orientation="left">
                                        <label style="color: #2d8cf0"><strong>{{item.title}}</strong></label>
                                    </Divider>
                                    <CheckboxGroup v-model="item.checkAllGroup">
                                        <Checkbox
                                                v-for="(k,v) in item.children"
                                                :label="k.title"
                                        ></Checkbox>
                                    </CheckboxGroup>
                                </FormItem>
                            </Form>
                        </div>

                    </Col>
                </Row>
            </TabPane>
            <Button @click="addAdminModalFN" type="primary" v-if="isaddadmin" slot="extra">添加员工</Button>
            <Button @click="updateRoleFn" type="primary" v-else slot="extra">保存</Button>
        </Tabs>

        <!----添加员工弹框--->
        <Modal
                v-model="addAdminModal"
                title="员工信息">
            <Form :label-width="100" inline >
                <FormItem label="姓名：" :required="true">
                    <Input v-model="addForm.name"  type="text" :maxlength="20" style="width: 300px" placeholder="请输入姓名" />
                </FormItem>
                <FormItem label="账号：" :required="true">
                    <Input v-model="addForm.account"  :maxlength="20" style="width: 300px" placeholder="账号长度6到20位,且必须包含数字和字母"  />
                </FormItem>
                <FormItem  label="手机号：" :required="true">
                    <Input v-model="addForm.phone"  :maxlength="11"  autocomplete="off"  style="width: 300px" placeholder="请输入11位手机号"  />
                </FormItem>
                <FormItem  label="密码：" :required="true">
                    <Input v-model="addForm.pass" type="password" password  autocomplete="off" :maxlength="21" style="width: 300px" placeholder="请输入密码"  />
                </FormItem>
                <FormItem  label="确认密码：" :required="true">
                    <Input v-model="addForm.definepass" type="password" password  autocomplete="off" :maxlength="21" style="width: 300px" placeholder="确认密码"  />
                </FormItem>

                <FormItem  label="门店：">
                    {{addForm.shopName}}
                </FormItem>

                <FormItem  label="角色：" >
                    <Select filterable style="width: 300px" v-model="addForm.rolename">
                        <Option v-for="(item,index) in RoleList"
                                :value="item.id"
                                :key="index"  placeholder="请选择">{{item.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem  label="备注：" >
                    <Input  type="textarea" :maxlength="100" show-word-limit v-model="addForm.remark"  style="width: 300px"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="primary" @click="addAdmin" :loading="buttonLoading">
                    <span v-if="!buttonLoading">保存</span>
                    <span v-else>加载中</span>
                </Button>
            </div>
        </Modal>

        <!----修改员工弹框--->
        <Modal
                v-model="AdminModal"
                title="添加员工">
            <Form :label-width="100" inline >
                <FormItem label="姓名：" :required="true">
                    <Input v-model="form.name"  type="text" :maxlength="20" style="width: 300px" placeholder="请输入姓名" />
                </FormItem>
                <FormItem label="账号：" :required="true">
                    {{form.account}}
                </FormItem>
                <FormItem  label="手机号：" :required="true">
                    <Input v-model="form.phone"  :maxlength="11" style="width: 300px" placeholder="请输入手机号"  />
                </FormItem>
                <FormItem  label="门店：">
                    {{form.shopName}}
                </FormItem>
                <FormItem  label="角色：" >
                    <Select style="width: 300px" v-model="form.rolename">
                        <Option v-for="(item,index) in RoleList"
                                :value="item.id"
                                :key="index"  placeholder="请选择">{{item.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="是否启用：">
                    <i-switch v-model="form.isopen" :disabled="ifrule==1">
                        <span slot="open">On</span>
                        <span slot="close">Off</span>
                    </i-switch>
                </FormItem>
                <FormItem  label="备注：" >
                    <Input  type="textarea" :maxlength="100" show-word-limit v-model="form.remark"  style="width: 300px"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="primary" @click="saveAdmin" :loading="buttonLoading" :disabled="ifrule==1">
                    <span v-if="!buttonLoading">保存</span>
                    <span v-else>加载中</span>
                </Button>
                <Button type="warning" @click="resultPass">初始化密码</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    import encrypt from '@/common/encrypt';
    export default {
        data () {
            return {
                cid:"",
                sid:'',
                isaddadmin:true,
                columns: [
                    {title: '姓名', key: 'name',align:'center'},
                    {title: '角色', key: 'rolename',align:'center' },
                    {title: '账号', key: 'account',align:'center' },
                    {title: '操作', key: 'edit' ,align:'center',slot: 'action', },
                ],
                data: [],
                RoleList:[],
                page:{
                    total:0,
                    page:1,
                    rows:13
                },
                addAdminModal:false,
                loadingTable:true,
                AdminModal:false,
                buttonLoading:false,
                //添加员工
                addForm:{
                    name:'',
                    account:'',
                    phone:'',
                    shopName:'',
                    rolename:'',
                    pass:'',
                    definepass:'',
                    remark:'',
                },

                //修改
                form:{
                    id:'',
                    name:'',
                    account:'',
                    phone:'',
                    shopName:'',
                    rolename:'',
                    isopen:true,
                    remark:'',
                },
                ifrule:0, //是否有权限0 有权限 1无权限

                /*以下权限模块*/
                RoleList:[],//职位列表
                rightTive:0,
                listsRole: [
                    {
                        title: "管理",
                        level: "1",
                        checked: false,
                        checkAllGroup:[],
                        children: [
                            { index: 79, title: "增值服务详情", checked: true },
                            { index: 94, title: "成本", checked: false },
                            { index: 7, title: "店员业绩", checked: false },
                            { index: 84, title: "前台收银", checked: false },
                            { index: 116, title: "总仓权限", checked: false },
                            { index: 109, title: "设置", checked: false },
                            { index: 103, title: "回收站", checked: false }
                        ]
                    },
                    {
                        title: "采购",
                        level: "1",
                        checked: false,
                        checkAllGroup:[],
                        children: [
                            { index: 105, title: "采购单详情", checked: false },
                            { index: 21, title: "采购报表", checked: false },
                            { index: 43, title: "采购开单", checked: false },
                            { index: 13, title: "采购历史", checked: false },
                            { index: 49, title: "添加供应商", checked: false },
                            { index: 50, title: "供应商详情", checked: false },
                            { index: 18, title: "供应商对账", checked: false },
                            { index: 66, title: "供应商对账明细", checked: false },
                            { index: 29, title: "供应商管理", checked: false },
                            // { index: 41, title: "撤销单历史", checked: false },
                            { index: 108, title: "撤销采购单", checked: false },
                            { index: 100, title: "采购退换", checked: false },
                            { index: 101, title: "采购退换历史", checked: false }
                        ]
                    },
                    {
                        title: "销售",
                        level: "1",
                        checked: false,
                        checkAllGroup:[],
                        children: [
                            { index: 81, title: "销售历史", checked: false },
                            { index: 82, title: "销售单详情", checked: false },
                            { index: 39, title: "销售开单", checked: false },
                            { index: 20, title: "销售报表", checked: false },
                            { index: 83, title: "销售退换", checked: false },
                            { index: 28, title: "客户管理", checked: false },
                            { index: 47, title: "客户详情", checked: false },
                            { index: 48, title: "添加客户", checked: false },
                            { index: 17, title: "客户对账", checked: false },
                            { index: 91, title: "客户对账详情", checked: false },
                            { index: 41, title: "撤销单历史", checked: false },
                            { index: 42, title: "销售退换历史", checked: false },
                            { index: 107, title: "撤销销售单", checked: false },
                            { index: 80, title: "积分调整", checked: false },
                            { index: 77, title: "积分明细", checked: false },
                            { index: 118, title: "草稿单", checked: false }
                        ]
                    },
                    {
                        title: "会员卡",
                        level: "1",
                        checked: false,
                        checkAllGroup:[],
                        children: [
                            { index: 8, title: "会员充值", checked: false },
                            { index: 67, title: "充值记录", checked: false },
                            { index: 68, title: "充值记录详情", checked: false },
                            { index: 104, title: "打印充值记录详情", checked: false }
                        ]
                    },
                    {
                        title: "商品管理",
                        level: "1",
                        checked: false,
                        checkAllGroup:[],
                        children: [
                            // { index: 21, title: "搜索", checked: false },
                            { index: 44, title: "新增商品", checked: false },
                            { index: 27, title: "商品列表", checked: false },
                            { index: 5, title: "颜色库设置", checked: false },
                            { index: 6, title: "规格库设置", checked: false },
                            { index: 121, title: "分类库设置", checked: false },
                            { index: 46, title: "商品详情", checked: false },
                            { index: 119, title: "复制商品", checked: false },
                            { index: 110, title: "自动生成条形码", checked: false }
                        ]
                    },
                    {
                        title: "仓库",
                        level: "1",
                        checked: false,
                        checkAllGroup:[],
                        children: [
                            { index: 10, title: "库存流水", checked: false },
                            { index: 11, title: "库存查询", checked: false },
                            { index: 12, title: "库存预警", checked: false },
                            { index: 35, title: "库存详情", checked: false },
                            { index: 36, title: "盘点详情", checked: false },
                            { index: 37, title: "调拨详情", checked: false },
                            { index: 99, title: "库存调拨", checked: false },
                            { index: 14, title: "盘点历史", checked: false },
                            { index: 15, title: "调拨历史", checked: false },
                            { index: 98, title: "库存盘点", checked: false },
                            { index: 114, title: "直营下拨", checked: false },
                            { index: 117, title: "代理下拨", checked: false },
                            { index: 115, title: "下拨历史", checked: false }
                        ]
                    },
                    {
                        title: "报表",
                        level: "1",
                        checked: false,
                        checkAllGroup:[],
                        children: [
                            // { index: 69, title: "统计报表", checked: false },
                            { index: 22, title: "盘点报表", checked: false },
                            { index: 23, title: "调拨报表", checked: false },
                            { index: 24, title: "热销商品", checked: false },
                            { index: 25, title: "营收报表", checked: false },
                            { index: 19, title: "经营概况", checked: false }
                        ]
                    },
                    {
                        title: "财务",
                        level: "1",
                        checked: false,
                        checkAllGroup:[],
                        children: [
                            { index: 16, title: "今日结余", checked: false },
                            { index: 30, title: "账户管理", checked: false },
                            { index: 51, title: "结算账户管理", checked: false },
                            { index: 52, title: "添加结算账户", checked: false },
                            { index: 53, title: "结算账户详情", checked: false },
                            { index: 54, title: "结算账户类型", checked: false },
                            { index: 92, title: "账户流水", checked: false },
                            { index: 64, title: "记一笔", checked: false },
                            { index: 65, title: "记一笔详情", checked: false },
                            { index: 26, title: "记一笔列表", checked: false }
                            // { index: 57, title: "账户信息", checked: false }
                        ]
                    },
                    {
                        title: "员工管理",
                        level: "1",
                        checked: false,
                        checkAllGroup:[],
                        children: [
                            { index: 31, title: "员工管理", checked: false },
                            { index: 58, title: "员工列表", checked: false },
                            { index: 90, title: "员工详情", checked: false },
                            { index: 60, title: "添加员工", checked: false },
                            { index: 59, title: "角色权限", checked: false },
                            { index: 61, title: "修改角色权限", checked: false },
                            { index: 62, title: "添加角色权限", checked: false },
                            { index: 63, title: "角色详情", checked: false }
                        ]
                    },
                    {
                        title: "多销货",
                        level: "1",
                        checked: false,
                        checkAllGroup:[],
                        children: [
                            { index: 106, title: "网单转销售单", checked: false },
                            { index: 38, title: "撤销网销单", checked: false },
                            { index: 72, title: "多销货商城", checked: false },
                            { index: 73, title: "网店管理", checked: false },
                            { index: 74, title: "多销货订单", checked: false },
                            { index: 75, title: "上架商品", checked: false },
                            { index: 93, title: "添加运费", checked: false },
                            { index: 111, title: "小程序订单通知", checked: false }
                        ]
                    },
                    {
                        title: "打印 ",
                        level: "1",
                        checked: false,
                        checkAllGroup:[],
                        children: [{ index: 32, title: "蓝牙列表", checked: false }]
                    }

                ],
                ids:0,//职位id
                rolename:'',
                indeterminate: true,
                checkAll: false,
                isShowaddname:false,
                isSisabled:false,
            }
        },


        created: function() {
            //DOM更新完之前请求数据
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.getAdminList()
            this.getRoleList()
            this.getShopId()

            var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
            if(!PermisCode.includes('60')){
                this.ifrule=1
            }


            /*判断是否购买蓝钻服务，否则就不让点击*/
            var shop = JSON.parse(localStorage.getItem("shop")).code;
            var shopArray = shop.split(",");
            shopArray.forEach(item => {
                if ((item == "100060" && name==1) ) { //100051皇冠  100060蓝钻 100059黄钻
                    this.isSisabled=false
                }else {
                    this.isSisabled=true
                }
            });
        },
        methods: {
            //获取员工列表
            getAdminList(){
                this.$Api.getAdminList({
                    cid: this.cid,
                    sid: this.sid,
                    page: this.page.page,
                    rows: this.page.rows,
                    isdel:0
                }).then(res => {
                    if(res.code==200){
                        if(res.data!=''){
                            this.page.total = res.count
                            res.data.forEach((item,index)=>{
                                if(!item.role){
                                    item.rolename = ' '
                                }else {
                                    item.rolename = item.role.name
                                }
                            })
                            this.data = res.data
                        }

                    }else {
                        this.$Message.warning(res.msg);
                    }
                    this.loadingTable=false
                });

            },
            //获取门店信息
            getShopId(){
                let data = {
                    id:this.sid
                };
                this.$Api.getShopId(data).then(res => {
                    if(res.code==200){
                        this.form.shopName =  res.data.name
                        this.addForm.shopName =  res.data.name
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //获取所有职位
            getRoleList(){
                this.$Api.getRoleList({
                    cid: this.cid,
                    sid: this.sid,
                }).then(res => {
                    if(res.code==200){
                        if(res.data!=''){
                            this.RoleList = res.data
                        }
                    }else {
                        this.$Message.warning(res.msg);
                    }
                    this.loadingTable=false
                });
            },
            addAdminModalFN(){
                if(this.ifrule==1){
                    this.$Message.warning('暂无权限');
                    return
                }
                this.addAdminModal=true
            },
            //添加员工
            addAdmin(){

                /**
                * 这里添加员工做校验，哎！
                * */
                if(this.addForm.name==''){
                    this.$Message.warning("姓名不能为空");
                    return
                }
                if (this.addForm.account == "") {
                    this.$Message.warning("账号不能为空");
                    return;
                }
                let zhReg = /^(?!(?:\d+|[a-zA-Z]+)$)[\da-zA-Z]{6,20}$/;
                if (!zhReg.test(this.addForm.account)) {
                    this.$Message.warning("账号长度6到20位，必须包含数字和字母，且不能有特殊字符!");
                    return;
                }
                if (this.addForm.phone=='') {
                    this.$Message.warning("手机号不能为空");
                    return
                }
                let telReg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
                if (!telReg.test(this.addForm.phone)) {
                    this.$Message.warning("手机号格式不正确");
                    return;
                }
                if (this.addForm.pass< 6) {
                    this.$Message.warning("密码至少为6位");
                    return;
                }
                if (this.addForm.pass != this.addForm.definepass) {
                    this.$Message.warning("请确认密码是否一致");
                    return;
                }

                this.buttonLoading=true
                this.$Api.addAdmin({
                    cid: this.cid,
                    sid: this.sid,
                    name: this.addForm.name,
                    account: this.addForm.account,
                    password: this.addForm.pass,
                    passwords: this.addForm.definepass,
                    outlet: this.addForm.shopName,
                    remark:  this.addForm.remark,
                    imgurl: '',
                    roleid:  this.addForm.rolename,
                    phone: this.addForm.phone,
                    email:'',
                    type: 2,
                }).then(res => {
                    if(res.code==200){
                        this.$Message.success("添加成功");
                        this.getAdminList()
                        this.addAdminModal=false
                        this.addForm.name=''
                        this.addForm.account=''
                        this.addForm.pass=''
                        this.addForm.definepass=''
                        this.addForm.remark=''
                        this.addForm.rolename=''
                        this.addForm.phone=''
                    }else {
                        this.$Message.warning(res.msg);
                    }
                    this.buttonLoading=false
                }).catch(err=>{
                    this.buttonLoading=false
                    this.$Message.warning(err.msg);
                });
            },
            // 修改员工
            editadmin(data){
                this.AdminModal=true
                this.form.isopen=true
                this.form.id = data.id
                this.form.name = data.name
                this.form.account = data.account
                this.form.phone = data.phone
                this.form.rolename = data.roleid
                this.form.remark = data.remark
            },
            //保存修改员工信息
            saveAdmin(){
                if(this.form.name==''){
                    this.$Message.warning("姓名不能为空");
                    return
                }
                if (this.form.phone=='') {
                    this.$Message.warning("手机号不能为空");
                    return
                }
                let telReg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
                if (!telReg.test(this.form.phone)) {
                    this.$Message.warning("手机号格式不正确");
                    return;
                }
                let isopen = 0;
                this.form.isopen? isopen=0:isopen=1
                this.$Api.updateAdmin({
                    cid: this.cid,
                    sid: this.sid,
                    id: this.form.id,
                    name: this.form.name,
                    roleid: this.form.rolename, //职位
                    phone: this.form.phone,
                    isdel: isopen, //0启用 1禁用
                    remark:this.form.remark, //备注信息
                }).then(res => {
                    if(res.code==200){
                        this.$Message.success("保存成功");
                        this.getAdminList()
                        this.AdminModal=false
                    }else {
                        this.$Message.warning(res.msg);
                    }
                    this.buttonLoading=false
                }).catch(err=>{
                    this.buttonLoading=false
                    this.$Message.warning(err.msg);
                });
            },

            //初始化密码
            resultPass(){
                /***
                 * 初始化密码与app同步，app发送什么数据，这里同步更改，
                 * 不要问我为什么，老子高兴这样写
                 * */
                this.$Api.updateAdmin({
                    id: this.form.id,
                    password:'e10adc3949ba59abbe56e057f20f883e'
                }).then(res => {
                    if(res.code==200){
                        this.$Message.success("初始化密码：123456");
                    }else {
                        this.$Message.warning(res.msg);
                    }
                    this.buttonLoading=false
                }).catch(err=>{
                    this.buttonLoading=false
                    this.$Message.warning(err.msg);
                });
            },
            onGongPageTotal(num){




                this.page.page = num
                this.getAdminList()
            },
            roleManagement(name){



                if(name==1){
                    this.isaddadmin=false
                }else {
                    this.isaddadmin=true
                }
            },


            /**以下为权限模块**/

            //获取职位列表
            getRoleList(){
                this.$Api.getRoleList({
                    cid: this.cid,
                    sid: this.sid,
                }).then(res => {
                    if(res.code==200){
                        if(res.data!=''){
                            this.RoleList = res.data
                            this.getRole(res.data[0].id)
                        }
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },

            //切换职位
            tabRoleFn(id,n){
                this.ids = id
                this.rightTive=n
                this.getRole(id)
                this.isShowaddname=false
            },
            //获取职位权限
            getRole(id){
                this.ids = id
                this.$Api.getRole({
                    id: id
                }).then(res => {
                    if(res.code==200){
                        if(res.data!=''){
                           let code = res.data.code.split(",");
                            this.listsRole.forEach(item=>{
                                item.checkAllGroup=[]
                            })
                            code.map(val => {
                                this.listsRole.map(item => {
                                    item.children.map(k => {
                                        if (val == k.index) {
                                             item.checkAllGroup.push(k.title)
                                        }

                                    });
                                });
                            });
                        }
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //修改权限
            updateRoleFn(){
                var strIds=[]
                this.listsRole.forEach(item=>{
                    if(item.checkAllGroup.length!=0){
                        item.checkAllGroup.forEach((k,i)=>{
                            item.children.forEach(m=>{
                                if(m.title==k){
                                    strIds.push(m.index)
                                }
                            })
                        })
                    }
                })
                this.$Api.updateRole({
                    id: this.ids,
                    code: strIds.join(",")
                }).then(res => {
                    if(res.code==200){
                        this.$Message.success('修改成功');
                        this. getRole(this.ids)
                    }else {
                        this.$Message.warning(res.msg);
                    }
                }).catch(err=>{
                    this.$Message.warning(err.msg);
                });

            },


            isShowaddnameFn(){
                this.isShowaddname=true
                this.listsRole.forEach(item=>{
                    item.checkAllGroup=[]
                })
                this.rightTive='10000'
            },
            cancelrolename(){
                this.rightTive=0
                this.isShowaddname=false
                this.getRoleList()

            },
            //保存职位
            adddateRoleFn(){
                if(this.rolename==''){
                    this.$Message.warning('角色名称不能为空');return
                }
                var strIds=[]
                this.listsRole.forEach(item=>{
                    if(item.checkAllGroup.length!=0){
                        item.checkAllGroup.forEach((k,i)=>{
                            item.children.forEach(m=>{
                                if(m.title==k){
                                    strIds.push(m.index)
                                }
                            })
                        })
                    }
                })
                if(strIds.length==0){
                    this.$Message.warning('请为角色设置权限');return
                }
                this.$Api.addRole({
                    cid: this.cid,
                    sid: this.sid,
                    name: this.rolename,
                    code: strIds.join(",")
                }).then(res => {
                    if(res.code==200){
                        this.$Message.success('添加成功');
                        this.rightTive=0
                        this.getRoleList()
                    }else {
                        this.$Message.warning(res.msg);
                    }
                }).catch(err=>{
                    this.$Message.warning(err.msg);
                });
            },




        }
    }
</script>


<style  lang="scss" scoped>
.position-list{
    border: 1px solid #dcdee2;
    border-radius: 3px;
    overflow: hidden;

    dd{
       padding: 10px;
        border-bottom: 1px solid #dcdee2;
        cursor: pointer;
    }
    dd:last-child{
         border:0;

     }
    dt:first-child{
       background: #ddd;
        padding: 10px;
    }
    dd:hover{
        background: #FAF2CC;
    }
    .selected-right{
        float: right;
    }
}
</style>